import { httpPost } from '@/request/http'

let path = '/reports/payable'

export default {
  getPages(params) {
    return httpPost(path, params)
  },
}
